module.exports = __webpack_public_path__ + "assets/img/playIcon.4853c791.png";